module.exports = __webpack_public_path__ + "static/media/calendar.595769e3.svg";